/**
 * Shared Wizard Styles for Poker Reborn
 *
 * Visual styles shared across all wizard content implementations
 * (Cash, Fast-Fold, SNG). The base CustomPlayWizard shell has its
 * own styles; these are for the content area.
 *
 * @see docs/screens/lobby/popups/CUSTOM_PLAY_WIZARD.md - Base wizard specs
 * @see docs/screens/lobby/popups/WIZARD_CASH.md - Cash content specs
 * @see docs/screens/lobby/popups/WIZARD_FASTFOLD.md - Fast-Fold content specs
 * @see docs/screens/lobby/popups/WIZARD_SNG.md - SNG content specs
 */

import type { ButtonStyle } from '@/components/common/Button';

// =============================================================================
// CONTENT STYLES
// =============================================================================

export const WIZARD_CONTENT_STYLES = {
  /** Section label text style (e.g., "Select Stakes:", "Select Seats:") */
  sectionLabel: {
    fill: 0x888899,
    fontSize: 13,
    fontFamily: 'Roboto, Arial, sans-serif',
  },

  /** Dimmed info text (e.g., "6-max only") */
  infoText: {
    fill: 0x666677,
    fontSize: 13,
    fontFamily: 'Roboto, Arial, sans-serif',
  },

  /** Seat toggle button (unselected) — used by Cash wizard */
  seatButton: {
    backgroundColor: 0x222233,
    hoverColor: 0x333344,
    pressColor: 0x111122,
    borderColor: 0x444455,
    textColor: 0xcccccc,
    cornerRadius: 6,
    fontSize: 14,
  } satisfies Partial<ButtonStyle>,

  /** Seat toggle button (selected) — used by Cash wizard */
  seatButtonSelected: {
    backgroundColor: 0xb8860b,
    hoverColor: 0xd8a62b,
    pressColor: 0x986600,
    borderColor: 0xffd700,
    textColor: 0x000000,
    cornerRadius: 6,
    fontSize: 14,
  } satisfies Partial<ButtonStyle>,

  /** Layout dimensions */
  gaps: {
    sectionLabelToButtons: 10,
    sectionToSection: 16,
    seatButtonHeight: 40,
    seatButtonGap: 10,
    infoTextGap: 8,
  },
};
